export default{
    helloWorld: "Hello World"
}